import * as React from 'react';

import classnames from 'classnames';

// @ts-expect-error - imported from .js/.jsx file
import {RetryRegularIcon} from 'shells/icon/svg/retry-regular-icon';
import {Body} from 'shells/typography/body';

import {useGetSessionUser} from '../../core/use-get-session-user';
import {useUpdateDismissibleUserSetting} from '../../core/use-update-dismissible-user-setting';

import styles from './undo-hide-sidebar-button.module.css';

const HAS_DISMISSED_ONBOARDING_SIDEBAR = 'has_dismissed_onboarding_sidebar';

type Props = {
    onUndo: () => void;
    isSidebarCollapsed?: boolean;
};

export function UndoHideSidebarButton(props: Props) {
    const {user} = useGetSessionUser();
    const updateSetting = useUpdateDismissibleUserSetting();

    const handleUndo = () =>
        updateSetting({
            userId: user ? user.id : '',
            settingName: HAS_DISMISSED_ONBOARDING_SIDEBAR,
            value: '0',
        }).then(() => {
            props.onUndo();
        });

    if (props.isSidebarCollapsed) {
        return (
            <div className={classnames(styles.container, styles['container-collapsed'])}>
                <button
                    onClick={handleUndo}
                    className={classnames(styles.undo, styles['undo-collapsed'])}
                >
                    <RetryRegularIcon size={15} alignCenter={true} />
                </button>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className='mb-4'>
                <Body size='small'>Your checklist won’t be shown again</Body>
            </div>
            <button onClick={handleUndo} className={styles.undo}>
                <div className='mr-4'>
                    <RetryRegularIcon size={15} alignCenter={true} />
                </div>
                <div className='font-size-small'>Undo</div>
            </button>
        </div>
    );
}
